import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { SocioEmotionalSkill } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SkillScore } from '../socio-emotional-skills-test-results.models';

const STRENGTHS_LIMIT = 3;
@Component({
  selector: 'app-socio-emotional-skills-test-results-strengths',
  templateUrl: './socio-emotional-skills-test-results-strengths.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-strengths.component.scss']
})
export class SocioEmotionalSkillsTestResultsStrengthsComponent implements OnInit {

  @Input() skills: SocioEmotionalSkill[] = [];
  @Input() skillScores: SkillScore[] = [];

  topSkills: { skill: SocioEmotionalSkill, score: number }[] = [];

  ngOnInit(): void {
    this.calculateTopSkills();
  }

  private calculateTopSkills(): void {
    const merged = this.skills.map(skill => {
      const scoreEntry = this.skillScores.find(s => s.skill._id === skill._id);
      return {
        skill,
        score: scoreEntry?.average ?? 0
      };
    });

    this.topSkills = merged
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);
  }
}
